import React from 'react';
const Icon = ({ id, sid, ...props }) => {
  const map = {
    2: sid,
    3: 'feed_transit',
    // 4: 'innings',
    5: sid,
    6: 'orner',
    7: 'yellowcrd',
    8: 'foul',
    9: 'offside',
    10: 'throw_in',
    11: 'goal_kick',
    12: 'barbell',
    13: sid,
    14: 'throw_in',
  };

  if (!map[id]) return null;
  return (
    <span className="ig-icon">
    <i className={`f-s-ico-${map[id]}`} style={{fontSize: 16}}/>
  </span>
  )
};

export default Icon;


// WEBPACK FOOTER //
// ./src/components/ig/icon.js